const STORAGE_KEY = 'muaazon:recently-viewed:v1';

const readItems = () => {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

const writeItems = (items) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, 8)));
  } catch {}
};

const renderCard = (item) => {
  const article = document.createElement('article');
  article.className = 'card recently-viewed-card';
  article.setAttribute('role', 'listitem');

  const link = document.createElement('a');
  link.href = item.url || `/products/${encodeURIComponent(item.handle)}`;
  link.className = 'recently-viewed-card__link';

  if (item.image) {
    const media = document.createElement('span');
    media.className = 'recently-viewed-card__media';
    const img = document.createElement('img');
    img.src = item.image;
    img.alt = item.alt || item.title || '';
    img.loading = 'lazy';
    img.decoding = 'async';
    media.append(img);
    link.append(media);
  }

  const body = document.createElement('span');
  body.className = 'recently-viewed-card__body';
  const title = document.createElement('strong');
  title.textContent = item.title || 'Product';
  const cta = document.createElement('span');
  cta.textContent = 'View product →';
  body.append(title, cta);
  link.append(body);
  article.append(link);
  return article;
};

export const initRecentlyViewedSection = (root) => {
  if (!root || root.dataset.recentlyViewedReady === 'true') return;
  root.dataset.recentlyViewedReady = 'true';

  const currentHandle = root.dataset.currentHandle || '';
  if (currentHandle) {
    const current = {
      handle: currentHandle,
      title: root.dataset.currentTitle || '',
      url: root.dataset.currentUrl || '',
      image: root.dataset.currentImage || '',
      alt: root.dataset.currentAlt || root.dataset.currentTitle || '',
    };
    const recorded = readItems().filter((item) => item?.handle && item.handle !== current.handle);
    recorded.unshift(current);
    writeItems(recorded);
  }

  const limit = Math.max(2, Number(root.dataset.limit) || 5);
  const items = readItems()
    .filter((item) => item?.handle && item.handle !== currentHandle)
    .slice(0, limit);

  if (!items.length) return;

  const grid = root.querySelector('[data-recently-viewed-grid]');
  if (!grid) return;

  items.forEach((item) => grid.append(renderCard(item)));
  root.hidden = false;
};

const boot = () => {
  const sections = document.querySelectorAll('[data-recently-viewed-section]');
  if (!sections.length) return;

  const load = () => sections.forEach((section) => initRecentlyViewedSection(section));

  if ('IntersectionObserver' in window) {
    sections.forEach((section) => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            load();
          }, { rootMargin: '200px 0px', threshold: 0.01 });
          observer.observe(section);
        }, { timeout: 1200 });
      } else {
        load();
      }
    });
  } else {
    load();
  }
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
else boot();
